/**
 * Opciones de las listas de destino dentro de la hoja (B6 · H55, H73):
 * a qué categoría pasan los movimientos de una que se borra y a qué cuenta
 * pasa el saldo de una que se cierra.
 */
import type { OpcionDestino } from '#components/mobile/ui/ConfirmarHoja';

type GrupoConCategorias = {
  name: string;
  hidden?: boolean | number | null;
  categories?: Array<{
    id: string;
    name: string;
    hidden?: boolean | number | null;
  }>;
};

/** Categorías visibles, en el orden del plan, con su grupo al lado. */
export function opcionesCategoriaDestino(
  grupos: GrupoConCategorias[],
): OpcionDestino[] {
  return grupos
    .filter(g => !g.hidden)
    .flatMap(g =>
      (g.categories ?? [])
        .filter(c => !c.hidden)
        .map(c => ({ id: c.id, nombre: c.name, detalle: g.name })),
    );
}

type CuentaDestino = {
  id: string;
  name: string;
  closed?: number | boolean;
  offbudget?: number | boolean;
};

/**
 * Cuentas abiertas salvo la que se cierra: primero las del presupuesto, luego
 * las de fuera (con «Fuera del presupuesto» al lado).
 */
export function opcionesCuentaDestino(
  cuentas: CuentaDestino[],
  excluir: string,
  textoFuera: string,
): OpcionDestino[] {
  const abiertas = cuentas.filter(c => !c.closed && c.id !== excluir);
  return [
    ...abiertas.filter(c => !c.offbudget),
    ...abiertas.filter(c => c.offbudget),
  ].map(c => ({
    id: c.id,
    nombre: c.name,
    detalle: c.offbudget ? textoFuera : undefined,
  }));
}
